/*
 * /patient/appointments — redirects the logged-in patient to their own appointment calendar
 */
import { Loader2 } from "lucide-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { trpc } from "../../trpc"
import { rolePageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/patient/appointments")({
	component: PatientAppointmentsRedirect,
	loader: rolePageLoader(["patient"]),
})

function PatientAppointmentsRedirect() {
	const navigate = useNavigate()
	const { data: patient } = trpc.patient.getByFilter.useQuery({ where: { active: true } })

	useEffect(() => {
		if (patient?.id) {
			navigate({ to: "/appointment/$patientId", params: { patientId: patient.id }, replace: true })
		}
	}, [patient?.id, navigate])

	return (
		<div className="flex h-screen items-center justify-center">
			<Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
		</div>
	)
}
